import login from './ru/login_page'
import home from './ru/home_page'
import server from './ru/server_page'
import pipeline from './en/pipeline'
import settings from './ru/settings_page'
import reports from './ru/reports_page'
import lists from './ru/lists'
import columns from './ru/columns'
import dashboards from './ru/dashboards'
import uisettings from './ru/ui_settings'

import menu from './ru/menu_list'
import button from './ru/buttons'
import notification from './ru/notifications'
import confirm from './ru/confirm'
import { placeholder, word, error, title } from './ru/other'

export default {
  login,
  home,
  server,
  pipeline,
  settings,
  reports,
  menu,
  button,
  notification,
  confirm,
  lists,
  columns,
  dashboards,
  uisettings,
  placeholder,
  word,
  error,
  title,

  password: 'Пароль',
  name: 'Имя',
  role: 'Роль'
}
